import { ICommonResponse } from 'api/types';

import { GET_PERSONAL_DIAGNOSTICS } from '../../actions';
import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';
import { connectReducers } from '../../utils';
import { IReducers } from '..';
import genericReducers from '../genericReducer';
import { IPersonalDiagnosticLearningGroup } from './../../api/types/diagnostic';

export type PersonalDiagnosticsState = ICommonResponse<IPersonalDiagnosticLearningGroup>;

const initialState: PersonalDiagnosticsState = {
  content: [],
  loading: false,
  requestCache: 'notCached',
};
const generic = genericReducers<PersonalDiagnosticsState>();
const personalDiagnostics: IReducers<PersonalDiagnosticsState> = {
  [GET_PERSONAL_DIAGNOSTICS[REQUEST]]: generic.get.request,
  [GET_PERSONAL_DIAGNOSTICS[SUCCESS]]: generic.get.success,
  [GET_PERSONAL_DIAGNOSTICS[FAILURE]]: generic.get.failure,
  [GET_PERSONAL_DIAGNOSTICS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, personalDiagnostics);
